<template>
    <v-flex xs12 sm12 md12 lg12 xl9 class="content">
        <template v-if="allowedTusTeam">
            <slot v-if="appLoaded"></slot>
        </template>
        <template v-if="!allowedTusTeam">
            <v-alert
                    :value="true"
                    type="error"
            >
                Dostop ni dovoljen!
            </v-alert>
        </template>
    </v-flex>
</template>

<script>
    import utils from "../store/utils";

    export default {
        name: "MainContentWrapperTeam",
        data() {
            return {
                tabs: null,
            }
        },
        beforeMount() {
            //this.$vuetify.theme.dark = true;
            this.activeSection = 'tus-team';
        },
        beforeDestroy() {
            //this.$vuetify.theme.dark = false;
            this.activeSection = 'account';
        },
        computed: {
            activeSection: utils.vuexBuildSetGet(this, null, 'application.activeSection'),
            is_tus_team: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.is_tus_team'),
            allowedTusTeam() {
                return this.is_tus_team;
            }
        },
        methods: {
            appLoaded() {
                return this.$store.state.application.loaded;
            }
        }
    }
</script>

<style scoped>

</style>